import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import PageContentWrapper from "../../components/PageContentWrapper.js";
import FormPartial from './FormPartial.js';
import { getApi } from '../../api/endpoints.js';
import { toast } from 'react-toastify';
import LeaseOffer from '../../models/LeaseOffer.js';
import Page from '../Page.js';
import uiManager from '../../../config/ui.js';
import PAGES from '../../data/PagesConstants.js';

const Edit = () => {
  let leaseOfferObj = new LeaseOffer();
  const [leaseOffer, setLeaseOffer] = useState(leaseOfferObj.toStateJson());
  const [fetchApi] = getApi('showLeaseOffer')
  const [updateApi] = getApi('updateLeaseOffer');
  const navigate = useNavigate();
  const params = useParams();

  const getRecord = async (params) => {
    try {
      let response = await fetchApi(params).unwrap();
      setLeaseOffer((new LeaseOffer(response.data.lease_offer)).toStateJson());
    } catch (error) {
    }
  }

  useEffect(() => {
    getRecord({ id: params.id, fields: "show" })

    setLeaseOffer((prevState)=>{
      return { ...prevState, user_id: params.fleet_owner_id }
    })
  }, []);

  const updateRecord = async (params) => {
    try {
      await updateApi(params).unwrap();
      toast.success('LeaseOffer Updated Successfully');
      navigate(-1)
    } catch (error) {
      toast.error('Something went wrong!')
    }
  }

  const handleSubmitFunction = () => {
    try {
      updateRecord((new LeaseOffer(leaseOffer)).toApiJson())
    } catch(error) {
      leaseOfferObj = new LeaseOffer(leaseOfferObj);
      leaseOfferObj.set_api_errors(error.data.data.errors);
      setLeaseOffer(leaseOfferObj.toStateJson())
    }
  }

  const handleCancelFunction = () => {
    navigate(-1);
  }

  return <Page
    uiPage={uiManager.getUiPage(PAGES.EditLeaseOfferPage.name)}
    breadcrumbs={[
      { label: "Home", url: '/dashboard' }, { label: "Fleet Owners", url: `/fleet_owners` },
      { label: `${params.fleet_owner_id}`, url: `/fleet_owners/${params.fleet_owner_id}` },
      { label: `Lease Offers`, url: `/fleet_owners/${params.fleet_owner_id}` },
      { label: "Edit" }
    ]}
    className={'edit-lease-offer-page'}
  >
    <PageContentWrapper contentHeading={"Update Lease Offer"}>
      <div className='m-3'>
        <div className='mb-4 col-md-12'>
          <form className="row g-3" autoComplete="off">
            <FormPartial leaseOffer={leaseOffer} setLeaseOffer={setLeaseOffer} />
            <div className='mb-4 col-md-12'>
              <div >
                <button style={{ float: 'inline-start' }} type="button" className="btn btn-voltup-theme" onClick={handleCancelFunction}>Back</button>
                <button type="button" className="btn btn-voltup-theme ms-3" onClick={handleSubmitFunction}>Update Offer</button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </PageContentWrapper>
  </Page>
}

export default Edit;
